import React from "react";
import { Table } from "antd";
import useColumnFilter from "../../../hooks/useColumnFilter";
import useGetPlatformColumns from "../../../hooks/platforms/useGetPlatformColumns";
import { ModulesTableComponent } from "../../ModulesTableComponent";
import useFilteredColumns from "../../../hooks/useFilteredColumns";

export const PlatformWithRolesAndModulesTableComponent = (props) => {
  const {
    data = { data: [], total: 0 },
    tableLoading,
    currentPagination,
    onPaginationChange,
    onSortChange,
    columnFilter,
    setColumnFilter,
  } = props;

  const platformColumns = useGetPlatformColumns();

  const { getColumnFilterProps } = useColumnFilter(
    columnFilter,
    setColumnFilter
  );

  let newCols = useFilteredColumns(platformColumns, getColumnFilterProps);

  return (
    <ModulesTableComponent
      data={data}
      onPaginationChange={onPaginationChange}
      tableColumns={newCols || []}
      currentPagination={currentPagination}
      onSortChange={onSortChange}
      tableLoading={tableLoading}
      hasSelection={false}
    />
  );
};
